import { AuthorizationType, PaymentCategoryType } from 'consts';
import { PROGRESS } from '../../config/config';
import { ICardContext } from '../../types/CardContext';

function updateContextProps(props: IAccordionItem & Partial<IContext> & Partial<ICardContext>) {
  const {
    type,
    paymentMethods,
    setAuthorizationType,
    setPaymentMethodAndProgressAndNotification,
    setPaymentMethodAndProgress,
    setPaymentMethod,
    paymentMethodType,
  } = props;

  if (
    setAuthorizationType &&
    setPaymentMethodAndProgressAndNotification &&
    setPaymentMethodAndProgress &&
    setPaymentMethod &&
    paymentMethodType !== type
  ) {
    switch (type) {
      case PaymentCategoryType.BLIK:
        setAuthorizationType({
          authorizationType: paymentMethods[0].authorizationType
            ? paymentMethods[0].authorizationType
            : AuthorizationType.CODE,
        });
        setPaymentMethodAndProgressAndNotification(
          paymentMethods[0].id,
          PaymentCategoryType.BLIK,
          paymentMethods[0].pmpt,
          paymentMethods[0].showPaymentNotification,
          paymentMethods[0].authorizationType === AuthorizationType.REDIRECT
            ? PROGRESS.BLIK_REDIRECT
            : PROGRESS.BLIK_CLICK_FIELD
        );
        break;
      case PaymentCategoryType.PBL:
        setPaymentMethodAndProgress('', PaymentCategoryType.PBL, 0, PROGRESS.SELECT_PBL_METHOD);
        break;
      case PaymentCategoryType.CARD:
        setPaymentMethodAndProgressAndNotification(
          paymentMethods[0].id,
          PaymentCategoryType.CARD,
          paymentMethods[0].pmpt,
          paymentMethods[0].showPaymentNotification,
          PROGRESS.SELECT_CARD_METHOD
        );
        break;
      case PaymentCategoryType.CARD_RECURRING:
        setPaymentMethodAndProgressAndNotification(
          paymentMethods[0].id,
          PaymentCategoryType.CARD_RECURRING,
          paymentMethods[0].pmpt,
          paymentMethods[0].showPaymentNotification,
          PROGRESS.SELECT_CARD_METHOD
        );
        break;
      case PaymentCategoryType.GOOGLE_PAY:
        setPaymentMethodAndProgressAndNotification(
          paymentMethods[0].id,
          PaymentCategoryType.GOOGLE_PAY,
          paymentMethods[0].pmpt,
          paymentMethods[0].showPaymentNotification,
          PROGRESS.SELECT_GPAY_METHOD
        );
        break;
      case PaymentCategoryType.APPLE_PAY:
        setPaymentMethodAndProgressAndNotification(
          paymentMethods[0].id,
          PaymentCategoryType.APPLE_PAY,
          paymentMethods[0].pmpt,
          paymentMethods[0].showPaymentNotification,
          PROGRESS.SELECT_APPLE_PAY_METHOD
        );
        break;
      case PaymentCategoryType.PAYPO:
        setPaymentMethodAndProgressAndNotification(
          paymentMethods[0].id,
          PaymentCategoryType.PAYPO,
          paymentMethods[0].pmpt,
          paymentMethods[0].showPaymentNotification,
          PROGRESS.SELECT_PAYPO_METHOD
        );
        break;
      case PaymentCategoryType.CLICK_TO_PAY:
        setPaymentMethodAndProgressAndNotification(
          paymentMethods[0].id,
          PaymentCategoryType.CLICK_TO_PAY,
          paymentMethods[0].pmpt,
          paymentMethods[0].showPaymentNotification,
          PROGRESS.SELECT_C2P_METHOD
        );
        break;
      default:
        throw new Error('Invalid category name');
    }
  }
}

export default updateContextProps;
